import { jsx as _jsx } from "react/jsx-runtime";

function SvgReplace() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 3.5a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1h-7a1 1 0 01-1-1v-7zm2 1v5h5v-5h-5zM9.572 2.6a3.9 3.9 0 00-3.9 3.9v1.198l-1.01-1.095a.9.9 0 00-1.323 1.221L5.91 10.61a.9.9 0 001.323 0l2.571-2.786a.9.9 0 00-1.322-1.22l-1.01 1.094V6.5c0-1.16.94-2.1 2.1-2.1H10a.9.9 0 100-1.8h-.428zm4.857 18.8a3.9 3.9 0 003.9-3.9v-1.198l1.01 1.095a.9.9 0 101.322-1.221L18.09 13.39a.9.9 0 00-1.323 0l-2.571 2.786a.9.9 0 001.322 1.22l1.01-1.094V17.5a2.1 2.1 0 01-2.1 2.1H14a.9.9 0 100 1.8h.428zM3.5 12.5a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1v-7a1 1 0 00-1-1h-7zm1 7v-5h5v5h-5z",
      fill: "currentColor"
    }, void 0)
  }), void 0);
}

export default SvgReplace;